import React, { ReactElement } from "react";
import StockOutProductSummaryReportList from "../../components/Reports/StockOutProductSummaryReportList";
import MainLayout from "../../components/Layouts";

const StockOutProductSummaryReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <StockOutProductSummaryReportList />
    </MainLayout>
  );
}; 

export default StockOutProductSummaryReportPage;
